import React from 'react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { AlertCircle } from 'lucide-react'

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="flex justify-center items-center min-h-[400px]">
      <Alert className="max-w-md">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription className="text-center">
          {message || 'Failed to load Instagram analytics data'}
        </AlertDescription>
      </Alert>
    </div>
  )
}

export default ErrorState


